class operators{
      constructor( 
            operId,
            login,
            nombre,
            nivel,
            fecAlta,
            fecBaja,
            pass,
            dbGrupo,
            ws,
            orden,
            roleId,
            cultureId,
            correoE,
            passAct,
            connectAs,
            connectPass,
            connectPassAct) {
    
      
                  this.operId=operId
                  this.login=login
                  this.nombre=nombre
                  this.nivel=nivel
                  this.fecAlta=fecAlta
                  this.fecBaja=fecBaja
                  this.pass=pass
                  this.dbGrupo=dbGrupo
                  this.ws=ws
                  this.orden=orden
                  this.roleId=roleId
                  this.cultureId=cultureId
                  this.correoE=correoE
                  this.passAct=passAct
                  this.connectAs=connectAs
                  this.connectPass=connectPass
                  this.connectPassAct=connectPassAct
      }
      static fromJson({ 
      operId,
      login,
      nombre,
      nivel,
      fecAlta,
      fecBaja,
      pass,
      dbGrupo,
      ws,
      orden,
      roleId,
      cultureId,
      correoE,
      passAct,
      connectAs,
      connectPass,
      connectPassAct
 }) {
        return new operators(
            operId,
            login,
            nombre,
            nivel,
            fecAlta,
            fecBaja,
            pass,
            dbGrupo,
            ws,
            orden,
            roleId,
            cultureId,
            correoE,
            passAct,
            connectAs,
            connectPass,
            connectPassAct);
      }
    }
    export default operators